export default __webpack_public_path__ + "static/media/640_dummy2016-wellness01-mobile-de.47757d50.png";